import { Box, Stack } from '@mui/material'
import BimLibraryComponent from './BimLibraryComponent'
import BimElementViewer from './BimElementViewer'
import { useCallback, useState } from 'react'
import { useOnResizeObserver } from '../../hooks/useOnResizeObserver'
import BimElementViewerOverlay from './BimElementViewerOverlay'

interface BimComponentProps {}

const BimComponent: React.FC<BimComponentProps> = ({}) => {
  const [ref, setRef] = useState<HTMLElement | null>(null)
  const [viewerDimensions, setViewerDimensions] = useState({
    width: 0,
    height: 0,
  })

  useOnResizeObserver(ref!, ({ width, height }) => {
    setViewerDimensions({ width, height })
  })

  const onRefChange = useCallback((node: HTMLElement | null) => {
    if (node) setRef(node)
  }, [])

  return (
    <Stack
      gap='0.7rem'
      sx={{
        padding: '0.7rem',
        width: '100%',
        height: '100%',
        boxSizing: 'border-box',
        background: '#FBFBFB',
      }}
    >
      <Box sx={{ display: 'flex', width: '100%', height: '60%' }}>
        <BimLibraryComponent />
      </Box>
      <Box sx={{ display: 'flex', width: '100%', height: '40%' }}>
        <BimElementViewer ref={onRefChange} />
        <BimElementViewerOverlay viewerSize={viewerDimensions} />
      </Box>
    </Stack>
  )
}

export default BimComponent
